import { GRADIENT } from './format'

interface SettingsToggleRowProps {
  label: string
  description?: string
  checked: boolean
  onChange: (checked: boolean) => void
  /** Hide the bottom divider — set on the last row of a group. */
  last?: boolean
  disabled?: boolean
}

export function SettingsToggleRow({
  label,
  description,
  checked,
  onChange,
  last,
  disabled,
}: SettingsToggleRowProps) {
  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        padding: '15px 0',
        borderBottom: last ? 'none' : '1px solid var(--line-soft)',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.55 : 1,
      }}
    >
      <div>
        <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--ink)' }}>{label}</div>
        {description && (
          <div style={{ fontSize: 12.5, color: 'var(--muted)', marginTop: 2 }}>{description}</div>
        )}
      </div>
      <input
        type="checkbox"
        role="switch"
        aria-label={label}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
      />
      <span
        aria-hidden
        style={{
          position: 'relative',
          flexShrink: 0,
          width: 42,
          height: 25,
          borderRadius: 999,
          background: checked ? GRADIENT : '#e2dccf',
          transition: 'background 0.15s',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: 3,
            left: checked ? 20 : 3,
            width: 19,
            height: 19,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 2px rgba(0,0,0,.2)',
            transition: 'left 0.15s',
          }}
        />
      </span>
    </label>
  )
}
